/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeMoveDocumentRequest, type ErrorResponse, type InternalErrorResponse, type MoveDocumentRequest } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/companydocs/documents/{documentId}/move
 */
export interface MoveRequestBuilder extends BaseRequestBuilder<MoveRequestBuilder> {
    /**
     * Files an existing document under a different folder and recalculates its display path. Send targetFolderId as null or leave it out to move the document back to the top level. The target is not verified: a folder id that does not exist is stored as given and the document's path falls back to the top level, which leaves it filed under a folder no listing will return — take the id from the folders endpoints rather than composing one. Repeating the same move is harmless. Nothing is returned on success.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: MoveDocumentRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Files an existing document under a different folder and recalculates its display path. Send targetFolderId as null or leave it out to move the document back to the top level. The target is not verified: a folder id that does not exist is stored as given and the document's path falls back to the top level, which leaves it filed under a folder no listing will return — take the id from the folders endpoints rather than composing one. Repeating the same move is harmless. Nothing is returned on success.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: MoveDocumentRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const MoveRequestBuilderUriTemplate = "{+baseurl}/api/companydocs/documents/{documentId}/move";
/**
 * Metadata for all the requests in the request builder.
 */
export const MoveRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: MoveRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeMoveDocumentRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
